// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__ApYt-","text":"PageHeader_text__3qWHH","button":"PageHeader_button__3QnET"};